import { render } from "./MortgageProtectionAnalysis.vue?vue&type=template&id=3bb55d67&scoped=true"
import script from "./MortgageProtectionAnalysis.vue?vue&type=script&lang=js"
export * from "./MortgageProtectionAnalysis.vue?vue&type=script&lang=js"

import "./MortgageProtectionAnalysis.vue?vue&type=style&index=0&id=3bb55d67&lang=css"
import "./MortgageProtectionAnalysis.vue?vue&type=style&index=1&id=3bb55d67&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb55d67"]])

export default __exports__